import Vue from 'vue';

export default {
    store(parametros) {
        return Vue.axios.post("perfiles-facturacion", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    update(parametros) {
        return Vue.axios.put("perfiles-facturacion", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    updatePassword(parametros) {
        return Vue.axios.put("perfiles-facturacion/password", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    updateTimbres(parametros) {
        return Vue.axios.post("perfiles-facturacion/agregar-timbres", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    delete(id) {
        return Vue.axios.delete("perfiles-facturacion/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    
}